<script setup lang="ts">
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from '@design-system/vue-ui';

defineProps<{
  title?: string;
}>();
</script>

<template>
  <Card>
    <CardHeader v-if="title || $slots.header">
      <CardTitle v-if="title">{{ title }}</CardTitle>
      <slot name="header" />
    </CardHeader>
    <CardContent>
      <slot />
    </CardContent>
    <CardFooter v-if="$slots.footer">
      <slot name="footer" />
    </CardFooter>
  </Card>
</template>
